var getPageItem = function getPageItem(page) {
  return {
    page: page,
    type: 'page'
  };
};

/**
 * Генерирует массив номеров страниц для пагинации с разделителями
 * @param currentPage - Текущая страница (начиная с 1)
 * @param totalPages - Общее количество страниц
 * @param siblingsCount - Количество соседних страниц с каждой стороны (по умолчанию 2)
 * @param boundaryCount - Минимальное количество страниц в начале/конце до появления разделителя (по умолчанию 5)
 */
export var generatePaginationItems = function generatePaginationItems(currentPage, totalPages) {
  var siblingsCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var boundaryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4;
  if (currentPage < 1 || totalPages < 1 || currentPage > totalPages) {
    return {
      list: [],
      showNextButton: false,
      showPrevButton: false
    };
  }

  // Если страниц мало, показываем все
  if (totalPages <= siblingsCount * 2 + 1) {
    return {
      list: Array.from({
        length: totalPages
      }, function (_, i) {
        return {
          page: i + 1,
          type: 'page'
        };
      }),
      showNextButton: false,
      showPrevButton: false
    };
  }
  var list = [];

  // Определяем диапазон страниц вокруг текущей
  var startPage = Math.max(1, currentPage - siblingsCount);
  var endPage = Math.min(totalPages, currentPage + siblingsCount);

  // Проверяем, находимся ли мы в начале списка (нужно показать минимум boundaryCount страниц)
  if (currentPage <= boundaryCount - siblingsCount - 1) {
    // Если мы в начале, показываем первые boundaryCount страниц без левого разделителя
    endPage = Math.max(boundaryCount, endPage);
  }

  // Проверяем, находимся ли мы в конце списка (нужно показать минимум boundaryCount страниц)
  if (currentPage >= totalPages - (boundaryCount - siblingsCount - 1)) {
    // Если мы в конце, показываем последние boundaryCount страниц без правого разделителя
    startPage = Math.min(totalPages - boundaryCount + 1, startPage);
  }

  // Определяем, нужно ли показывать левый разделитель
  var shouldShowLeftDots = startPage > 1 && startPage > boundaryCount - siblingsCount - 1;

  // Определяем, нужно ли показывать правый разделитель
  var shouldShowRightDots = endPage < totalPages && endPage < totalPages - (boundaryCount - siblingsCount) + 2;
  // 1. Если нужен левый разделитель
  if (shouldShowLeftDots) {
    // Всегда добавляем первую страницу
    list.push(getPageItem(1));

    // Добавляем разделитель
    list.push({
      type: 'separator'
    });
  } else {
    // Если левый разделитель не нужен, добавляем все страницы от 1 до startPage-1
    for (var i = 1; i < startPage; i += 1) {
      list.push(getPageItem(i));
    }
  }

  // 2. Добавляем центральный диапазон страниц
  for (var _i = startPage; _i <= endPage; _i += 1) {
    list.push(getPageItem(_i));
  }

  // 3. Если нужен правый разделитель
  if (shouldShowRightDots) {
    // Добавляем разделитель
    list.push({
      type: 'separator'
    });

    // Всегда добавляем последнюю страницу
    list.push(getPageItem(totalPages));
  } else {
    // Если правый разделитель не нужен, добавляем все страницы от endPage+1 до totalPages
    for (var _i2 = endPage + 1; _i2 <= totalPages; _i2 += 1) {
      list.push(getPageItem(_i2));
    }
  }
  return {
    list: list,
    showNextButton: shouldShowRightDots,
    showPrevButton: shouldShowLeftDots
  };
};